// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { SportsArrow } from '../../assets/svg/sports-menu';
import { Target } from '../../client';
import theme from '../../styled-components/dark';

const Line = styled.div`
  margin-top: 1em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.4em;

  & svg {
    height: 1.9em;
    width: 1.9em;
  }
`;

const LabelWithIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const LabelWrapper = styled.span`
  color: ${theme.TopActionLine.Label.color};
  font-weight: bold;
  font-size: 1.2em;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const TopActionLineButton = styled.div`
  background-color: ${theme.TopActionLine.Button.backgroundColor};
  border-radius: 9999px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ $hasArrow }) =>
    $hasArrow
      ? css`
          padding: 0.2em 0.3em 0.2em 0.7em;
        `
      : css`
          padding: 0.2em 0.7em 0.2em 0.7em;
        `}

  ${Target.__MOBILE__
    ? css`
        &:active {
          & svg {
            transform: rotateZ(90deg) scale(0.67) translateY(-0.2em);
          }
        }
      `
    : css`
        &:hover {
          & svg {
            transform: rotateZ(90deg) scale(0.67) translateY(-0.2em);
          }
        }
      `}
`;

const ButtonLabelWithArrow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ButtonLabel = styled.span`
  color: ${theme.TopActionLine.Button.color};
  font-weight: bold;
  font-size: 0.8em;
`;

const ButtonArrow = styled(SportsArrow)`
  height: 1.2em;
  width: 1.2em;

  transform: rotateZ(90deg) scale(0.67);
  transition: transform 150ms ease-in-out;

  & path {
    stroke-width: 1.2px;
  }
`;

type TopActionLineProps = {
  className?: string;
  ctaLabel?: string;
  icon?: unknown;
  label: string;
  onButtonClick?: () => void;
  showArrow?: boolean;
  showButton?: boolean;
};

const TopActionLine = ({
  className,
  ctaLabel,
  icon,
  label,
  onButtonClick = () => {},
  showArrow = false,
  showButton = false,
}: TopActionLineProps) => {
  return (
    <Line className={className}>
      <LabelWithIconWrapper>
        <IconWrapper>{icon}</IconWrapper>
        <LabelWrapper>{label}</LabelWrapper>
      </LabelWithIconWrapper>

      {showButton ? (
        <ButtonWrapper>
          <TopActionLineButton onClick={onButtonClick} $hasArrow={showArrow}>
            <ButtonLabelWithArrow>
              <ButtonLabel>{ctaLabel}</ButtonLabel>
              {showArrow ? <ButtonArrow /> : null}
            </ButtonLabelWithArrow>
          </TopActionLineButton>
        </ButtonWrapper>
      ) : null}
    </Line>
  );
};

export default TopActionLine;
